import { useAccountLayoutContext } from '../components/AccountProfileContext'
import { asyncTimeout } from '../helpers/asyncTimeout'

export const useProfile = () => {
  const { omneoClient, cacheConfig } = useAccountLayoutContext()

  const getUnassignedItems = async (flush = false) => {
    if (flush) {
      cacheConfig.updateCacheConfig('UnassignedItems', null)
    }
    const cachedUnassignedItems = cacheConfig.cacheData.UnassignedItems
    if (!cachedUnassignedItems) {
      const unassignedItems = await omneoClient.profileClient.getUnassignedTransactionItems({ filterOutExpired: false, filterReturned: true })
      cacheConfig.updateCacheConfig('UnassignedItems', unassignedItems)
      return unassignedItems
    }
    return cachedUnassignedItems
  }

  const getUnexpiredUnassignedItems = async (flush = false) => {
    if (flush) {
      cacheConfig.updateCacheConfig('UnexpiredUnassignedItems', null)
    }
    const cachedUnexpiredUnassignedItems = cacheConfig.cacheData.UnexpiredUnassignedItems
    if (!cachedUnexpiredUnassignedItems) {
      const unexpiredUnassignedItems = await omneoClient.profileClient.getUnassignedTransactionItems({ filterOutExpired: true, filterReturned: true })
      cacheConfig.updateCacheConfig('UnexpiredUnassignedItems', unexpiredUnassignedItems)
      return unexpiredUnassignedItems
    }
    return cachedUnexpiredUnassignedItems
  }

  const getChildren = async (flush = false) => {
    if (flush) {
      cacheConfig.updateCacheConfig('ProfileConnections', null)
    }
    const cachedProfileConnections = cacheConfig.cacheData.ProfileConnections
    if (!cachedProfileConnections) {
      const connections = await omneoClient.profileClient.getChildren()
      cacheConfig.updateCacheConfig('ProfileConnections', connections)
      return connections
    }
    return cachedProfileConnections
  }

  const getBalance = async (flush = false) => {
    if (flush) {
      cacheConfig.updateCacheConfig('Balance', null)
    }
    const cachedBalance = cacheConfig.cacheData.Balance
    if (!cachedBalance || flush === true) {
      asyncTimeout(2400)
      const balance = await omneoClient.profileClient.getBalance()
      cacheConfig.updateCacheConfig('Balance', balance)
      return balance
    }
    return cachedBalance
  }

  return { getUnassignedItems, getChildren, getBalance, getUnexpiredUnassignedItems }
}
